import type { SupabaseClientOptions } from '@supabase/supabase-js';

export const settings: SupabaseClientOptions<'public'> = {
  // Enable magic-link auth to exchange code for session and keep
  // same callback URL implemementation as the oauth flow
  auth: {
    flowType: 'pkce',
  },
};
